/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes } from 'react';
import ScanImg from './images/Scan@2x.png'
import { Table } from 'components/UI'
import {alert} from 'util/alert'
import './Modal.scss';
import addAttendanceScan from 'controllers/lesson/addAttendanceScan'
import moment from 'moment'

export const MIN_INTERVAL_FOR_LEGIT_INPUT = 200;

class ModalContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      table: [],
      scanSuccess: false
    }


    this.recordScanner = this.recordScanner.bind(this);
    this.submitBarcode = this.submitBarcode.bind(this);
    this.legitInput = '';
  }

  componentDidMount(){
    if(localStorage.getItem('scan_table')){
      let scanTable = localStorage.getItem('scan_table')
      let schoolId = localStorage.getItem('schoolId')

      let table = JSON.parse(scanTable)
      if(table[0].schoolId == schoolId){
        this.setState({table})
      }
    }
  }

  componentWillMount() {
    window.addEventListener('keypress', this.recordScanner)
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.recordScanner)
  }

  recordScanner(e) {
    e.preventDefault();

    clearTimeout(this.recordScannerTimeout);

    if (e.charCode === 13) {
      this.submitBarcode(this.legitInput);
      return;
    }
    this.legitInput += e.key;

    this.recordScannerTimeout = setTimeout(()=>{
      this.submitBarcode(this.legitInput);
    }, MIN_INTERVAL_FOR_LEGIT_INPUT)
  }

  submitBarcode(code) {
    let {table} = this.state;
    let schoolId = localStorage.getItem('schoolId')
    let current_time = new moment ().format("HH:mm");
    this.legitInput = '';

    addAttendanceScan(schoolId, {code})
    .then((res) => {
      if(res.result == 'success'){
        this.setState({scanSuccess: true})
        setTimeout(() => { this.setState({scanSuccess: false})}, 1000)

        let schoolId = localStorage.getItem('schoolId')
        let obj = {
          schoolId, 
          name: res.student_name || res.teacher_name, 
          class: res.class_name || '', 
          lesson: res.lesson_name || '', 
          clock: res.operation_type || '' ,
          time: current_time
        }

        let newTable = [obj, ...this.state.table]

        if(newTable.length > 6){
          newTable.pop()
        }
        this.setState({hideTable: true}, () => {
          this.setState({ table: newTable, hideTable: false }, () => {
            localStorage.setItem('scan_table', JSON.stringify(this.state.table))
          })
        })
      } else if (res.result == 'failure' && res.reason == 'student has no lesson or has checked in'){
        alert.warning(__('Student has already checked in or has no lesson', 'attendanceScan'))
      } else if (res.result == 'failure' && res.reason == 'Invalid code or not a student of this school'){
        alert.warning(__('Student does not exist in school or invalid code', 'attendanceScan'))
      } else if (res.result == 'failure' && res.reason == 'you have missed the lesson'){
        alert.warning(__('Student has missed the lesson', 'attendanceScan'))
      }
    })
  }

  render() {
    let {table, hideTable, scanSuccess} = this.state;
    let successClass = scanSuccess === true ? 'showCheck' : 'noShowCheck'

    let fields = [
      {
        name: 'name',
        title: __('Students', 'attendanceScan')
      },
      {
        name: 'class',
        title: __('Class', 'attendanceScan')
      },
      {
        name: 'lesson',
        title: __('Lesson', 'attendanceScan')
      },
      {
        name: 'clock',
        title: __('Clock In/Clock Out', 'attendanceScan'),
        getTdContent: ({ trData: data })=>{
          return <div>{data.clock === 1 ? __('Clock In', 'attendanceScan') : __('Clock Out', 'attendanceScan') }</div>
        },
      },
      {
        name: 'time',
        title: __('Time', 'attendanceScan')
      }
    ]

    return (
      <div className='attendance-scan-modal-content'>
        <img src={ScanImg} className='scan-image' />
        <div className='text-center circle-container'>
          <div className='circle1'></div>
          <div className='circle2'></div>
          <div className='circle3'></div>
          <div className='circle4'></div>
          <div className='circle5'></div>
          <img className={successClass} src={require('data/images/Group@2x.png')} />
        </div>
        <div className='scan-note-red text-center'>{__('Scanning for attendance, please do not close this window', 'attendanceScan')}</div>
        { hideTable != true && <Table
          data={table}
          fields={fields}
          className='scan-table'
          settingWidth={'15%'}
          useMultiSelection={false}
          oneSettingPerRow={false}
          dropdownGuideWidth={160}
          dropdownGuideHeight={228}
          usePagination={false}
        />}
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/AttendanceScan/ModalContent.js